(() => {
  /**
   * Handle the devil character spine animations
   */
  class ReelBorderFire extends PIXI.Container {
    constructor() {
      super();

      this._colourTypes = ["Normal", "Blue", "Green", "Red"];
      this._positions = ["Left", "Right", "Top", "Bottom"];
      this._currentColour = "Normal";
      this._coordinates = {
        Left: { x: 242, y: 440 },
        Right: { x: 1090, y: 440 },
        Top: { x: 665, y: 180 },
        Bottom: { x: 665, y: 700 },
      };
      this._intenseCoordinates = {
        Left: { x: 225 },
        Right: { x: 1104 },
        Top: { y: 163 },
        Bottom: { y: 715 },
      };

      // Reel Border Fire spine assets
      this._reelBorderFireAssets = {};

      this._switchColourTweens = [];
      this._playAnimationTweens = [];

      Reflex.registerEventHandler("orientationChange", this._orientationChange.bind(this));
    }

    /**
     * Initialise the class
     */
    initialise() {
      this._positions.forEach((position) => {
        this._reelBorderFireAssets[position] = this._colourTypes.reduce((acc, colour) => {
          acc[colour] = resourceManager.createObject("spine", `ReelBorderFire${colour}${position}`, this, {
            name: `ReelBorderFire${colour}${position === "Bottom" ? "Top" : position}`,
            defaultAnimation: "animation",
            ...this._coordinates[position],
          });
          if (position === "Bottom") {
            acc[colour].scale.y = -1;
            systemData.isLandscape && (acc[colour].visible = false);
          }
          if (colour !== "Normal") {
            acc[colour].alpha = 0;
          }
          return acc;
        }, {});
      });
      this._playAnimation();
    }
    /**
     * Play the animation for the reel border fire
     * @param {String} colourToPlay
     */
    _playAnimation(colourToPlay = "Normal") {
      for (const position in this._reelBorderFireAssets) {
        this._reelBorderFireAssets[position][colourToPlay].play("animation", true);
        const tween = gsap.to(this._reelBorderFireAssets[position][colourToPlay], { alpha: 1, duration: 0.3 });
        this._playAnimationTweens.push(tween);
      }
      Promise.all(this._playAnimationTweens).then(() => (this._playAnimationTweens.length = 0));
      this._currentColour = colourToPlay;
    }

    /**
     * Switch to a specific colour and play the animation
     * @param {String} colourToSwitchTo
     */
    switchColour(colourToSwitchTo = "Normal", fadeOutDuration = 0.3) {
      if (colourToSwitchTo !== this._currentColour) {
        if (colourToSwitchTo !== "Normal") {
          soundManager.play("devilLaugh3");
        }
        const currentColour = this._currentColour;
        for (const position in this._reelBorderFireAssets) {
          const tween = gsap.to(this._reelBorderFireAssets[position][currentColour], {
            alpha: 0,
            duration: fadeOutDuration,
            onComplete: () => {
              this._reelBorderFireAssets[position][currentColour].stop();
            },
          });
          this._switchColourTweens.push(tween);
        }
        Promise.all(this._switchColourTweens).then(() => (this._switchColourTweens.length = 0));
        this._playAnimation(colourToSwitchTo);
        if (colourToSwitchTo === "Normal" && !gameController.inFreeSpins) {
          this.adjustIntensity(false);
        } else {
          this.adjustIntensity(true);
        }
      }
    }

    slamStop() {
      if (this._switchColourTweens.length) {
        this._switchColourTweens.forEach((tween) => {
          tween.progress(1);
        });
        this._playAnimationTweens.forEach((tween) => {
          tween.progress(1);
        });
        // this._switchColourTweens.length = 0;
        // for (const position in this._reelBorderFireAssets) {
        //   this._reelBorderFireAssets[position][this._currentColourcurrentColour].alpha = 0;
        // }
      }
    }

    /**
     * Adjust the flame intensity
     * @param {Boolean} increase - true/false
     */
    adjustIntensity(increase, postBigWin = false) {
      if (!postBigWin || (postBigWin && this._currentColour === "Normal")) {
        for (const position in this._reelBorderFireAssets) {
          const adjustmentCoordinates = increase ? this._intenseCoordinates[position] : this._coordinates[position];
          gsap.to(this._reelBorderFireAssets[position][this._currentColour], {
            ...adjustmentCoordinates,
            duration: 0.5,
          });
        }
      }
    }

    /**
     * Handle orientation change
     * @param {boolean} isLandscape
     */
    _orientationChange(isLandscape) {
      this._colourTypes.forEach((colour) => {
        if (gameController.gameLoaded) {
          if (this._reelBorderFireAssets["Bottom"][colour]) {
            this._reelBorderFireAssets["Bottom"][colour].visible = !isLandscape;
            this._reelBorderFireAssets["Bottom"][colour].scale.y = -1;
          }
        }
      });
    }
  }

  resourceManager.registerObjectType(
    "reelBorderFire",
    () => new ReelBorderFire(),
    () => {},
    () => []
  );
})();
